import * as questionIds from "../../consultationQuestions/questionIds";

export const healthQuestions = [
    {
        id: questionIds.HealthUnableToCarryOut,
        questionText: "Unable to carry out medical",
    },
    {
        id: questionIds.HealthUnableToCarryOutReason,
        questionText: "Reason medical not carried out",
    },
    {
        id: questionIds.OnReviewOfQuestionnaireByEmployeeHaveTheyTickedYesToAny,
        questionText: "On review of the health questionnaire completed by the employee have they ticked yes to any questions?",
    },
    {
        id: questionIds.PleaseProvideFurtherInformationOnTheConditionSymptomsHighlighted,
        questionText: "Please provide further information on the condition/symptoms highlighted?",
    },
    {
        id: questionIds.Height,
        questionText: "Height (cm)",
    },
    {
        id: questionIds.Weight,
        questionText: "Weight (KG)",
    },
    {
        id: questionIds.Bmi,
        questionText: "BMI",
    },
    {
        id: questionIds.SystolicBloodPressure,
        questionText: "Systolic Blood Pressure (mmHG)",
    },
    {
        id: questionIds.DiastolicBloodPressure,
        questionText: "Diastolic Blood Pressure (mmHG)",
    },
    {
        id: questionIds.SystolicBloodPressureTwo,
        questionText: "Systolic Blood Pressure (mmHG) Reading Two",
    },
    {
        id: questionIds.DiastolicBloodPressureTwo,
        questionText: "Diastolic Blood Pressure (mmHG) Reading Two",
    },
    {
        id: questionIds.SystolicBloodPressureThree,
        questionText: "Systolic Blood Pressure (mmHG) Reading Three",
    },
    {
        id: questionIds.DiastolicBloodPressureThree,
        questionText: "Diastolic Blood Pressure (mmHG) Reading Three",
    },
    {
        id: questionIds.SystolicBloodPressureFour,
        questionText: "Systolic Blood Pressure (mmHG) Reading Four",
    },
    {
        id: questionIds.DiastolicBloodPressureFour,
        questionText: "Diastolic Blood Pressure (mmHG) Reading Four",
    },
    {
        id: questionIds.SystolicBloodPressureFive,
        questionText: "Systolic Blood Pressure (mmHG) Reading Five",
    },
    {
        id: questionIds.DiastolicBloodPressureFive,
        questionText: "Diastolic Blood Pressure (mmHG) Reading Five",
    },
    {
        id: questionIds.PulseRate,
        questionText: "Pulse Rate (bpm)",
    },
    {
        id: questionIds.PulseRhythm,
        questionText: "Pulse Rhythm",
    },
    {
        id: questionIds.Cholesterol,
        questionText: "Cholesterol (mmol/L)",
    },
    {
        id: questionIds.BloodSugar,
        questionText: "Blood Sugar (mmol/l)",
    },
    {
        id: questionIds.Psa,
        questionText: "PSA",
    },
    {
        id: questionIds.GPSelfReferralLetterIssuedRegardingBloodPressureOrPulse,
        questionText: "GP self referral letter issued regarding blood pressure or pulse?",
    },
    {
        id: questionIds.Whisper,
        questionText: "Has a Whisper Test been carried out?",
    },
    {
        id: questionIds.WhisperRightEarPassed,
        questionText: "Right Ear",
    },
    {
        id: questionIds.WhisperLeftEarPassed,
        questionText: "Left Ear",
    },
    {
        id: questionIds.BloodLeftEar,
        questionText: "Wax Left Ear",
    },
    {
        id: questionIds.BloodRightEar,
        questionText: "Wax Right Ear",
    },
    {
        id: questionIds.GPSelefReferralLetterIssuedRegardingWhisperTestResult,
        questionText: "GP self referral letter issued regarding Whisper Test result?",
    }
];
